import { updateHeaders } from 'utils/axios';
import { Response } from '../../models/response';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import {
    authenticationAction,
    LoginResp,
    loginThunk,
} from '../../redux/slices/authentication';
import storageService, { Locals } from '../../utils/storageService';
import httpApi from '../api/httpApi';
import useShopifyCart from '../shopify/useShopifyCart';
import useShopifyCustomer from '../shopify/useShopifyCustomer';
import useCart from '../cart/useCart';

const useAuth = () => {
    const dispatch = useAppDispatch();
    const LOGIN_URL = '/api/v1/login';
    const LOGOUT_URL =
        process.env.REACT_APP_SHOPIFY_STORE_URL + '/account/logout';
    const cart = useCart();
    const shopifyCustomer = useShopifyCustomer();

    const { isLoggedIn, authorizations, fetching, user } = useAppSelector(
        (state) => state.authentication
    );

    const initAuthData = (accessToken: string) => {
        storageService.setItem(Locals.ACCESS_TOKEN, accessToken);
        updateHeaders();
    };

    const login = (
        email: string,
        password: string
    ): Promise<Response<LoginResp>> => {
        return dispatch(loginThunk({ email, password }))
            .unwrap()
            .then((data) => {
                initAuthData(data.getData().token);
                return data;
            });
    };

    const createCart = (loginToken): Promise<any> => {
        return shopifyCustomer
            .getCustomerAccessTokenWithMultipass(loginToken)
            .then((response) => {
                storageService.setItem(
                    Locals.SHOPIFY_ACCESS_TOKEN,
                    response.customerAccessToken.accessToken
                );
                return cart.createCart().then((cartResp) => {
                    storageService.setItem(
                        Locals.CART_TOKEN,
                        cartResp.cartCreate.cart.id
                    );
                    return cartResp;
                });
            });
    };

    const loginForRedirect = (email: string, password: string) => {
        return httpApi
            .post<LoginResp>(LOGIN_URL, {
                email,
                password,
            })
            .then((data) => {
                initAuthData(data.getData().token);
                return createCart(data.getData().shopify_login_token).then(
                    () => {
                        return data;
                    }
                );
            });
    };

    const clearStorage = () => {
        storageService.removeItem(Locals.ACCESS_TOKEN);
    };

    const logout = () => {
        clearStorage();
        storageService.removeItem(Locals.CART_TOKEN);
        // dispatch(authenticationAction.logout());
        window.location.replace(LOGOUT_URL);
    };

    const forceLogout = () => {
        clearStorage();
        storageService.removeItem(Locals.CART_TOKEN);
        dispatch(authenticationAction.logout());
    };

    return {
        isLoggedIn,
        authorizations,
        fetching,
        user,
        login,
        loginForRedirect,
        logout,
        forceLogout,
        initAuthData,
        clearStorage,
    };
};

export default useAuth;
